import { render, staticRenderFns } from "./ColumnInput.vue?vue&type=template&id=46ec1270&"
import script from "./ColumnInput.vue?vue&type=script&lang=js&"
export * from "./ColumnInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports